var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8057 67.6794C48.1346 67.4706 48.4935 67.3124 48.8667 67.2006C63.012 62.9621 73.3202 49.8448 73.3202 34.32C73.3202 15.3656 57.9546 0 39.0002 0C20.0458 0 4.68018 15.3656 4.68018 34.32C4.68018 47.8227 12.478 59.5042 23.816 65.1068C23.8288 65.1132 23.8236 65.1326 23.8093 65.1315C23.8002 65.1308 23.7932 65.1396 23.796 65.1483L26.904 74.9903C27.6949 77.4949 30.644 78.5705 32.8616 77.1631L47.8057 67.6794Z",
    fill: "#ED0131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8137 27.6381C49.6421 26.8097 49.6421 25.4666 48.8137 24.6382L48.3622 24.1867C47.5338 23.3583 46.1907 23.3583 45.3623 24.1867L39.0002 30.5488L32.6381 24.1867C31.8097 23.3583 30.4666 23.3583 29.6382 24.1867L29.1867 24.6382C28.3583 25.4666 28.3583 26.8097 29.1867 27.6381L35.5488 34.0002L29.1867 40.3623C28.3583 41.1907 28.3583 42.5338 29.1867 43.3622L29.6382 43.8137C30.4666 44.6421 31.8097 44.6421 32.6381 43.8137L39.0002 37.4516L45.3623 43.8137C46.1907 44.6421 47.5338 44.6421 48.3622 43.8137L48.8137 43.3622C49.6421 42.5338 49.6421 41.1907 48.8137 40.3623L42.4516 34.0002L48.8137 27.6381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailLogo);
export default __webpack_public_path__ + "static/media/fail-logo.8a2893fe51473c6ed11cb0437c30f937.svg";
export { ForwardRef as ReactComponent };